var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseFoldersGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 15.8333V6.29085C1.66663 5.08763 1.66663 4.48602 1.86939 4.01373C2.12221 3.42488 2.5915 2.95558 3.18035 2.70277C3.65264 2.5 4.24833 2.5 5.45748 2.5H5.86922C6.37345 2.5 6.85058 2.72828 7.16697 3.12091L8.68121 5M8.68121 5H13.3333C14.5 5 15.0835 5 15.5291 5.22707C15.9211 5.42681 16.2398 5.74552 16.4395 6.13752C16.6666 6.58317 16.6666 7.16656 16.6666 8.33333V9.16667M8.68121 5H5.83329",
    stroke: "#00B074",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63164 12.93L2.88032 12.3111C3.49187 10.7887 3.79765 10.0276 4.43529 9.5978C5.07293 9.16797 5.89627 9.16797 7.54293 9.16797H14.2599C16.5003 9.16797 17.6205 9.16797 18.1185 9.90022C18.6164 10.6326 18.2004 11.6681 17.3683 13.7393L17.1196 14.3582C16.508 15.8806 16.2023 16.6416 15.5646 17.0715C14.927 17.5013 14.1036 17.5013 12.457 17.5013H5.74006C3.49963 17.5013 2.37942 17.5013 1.88148 16.7691C1.38353 16.0367 1.79957 15.0011 2.63164 12.93Z",
    stroke: "#00B074",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseFoldersGreen);
export default __webpack_public_path__ + "static/media/case-folders-green.c7e7de0430ee610406f72e9bc4b69cf9.svg";
export { ForwardRef as ReactComponent };